export const AttentionPoint = ({ type }: { type: string }) => {
  switch (type) {
    case 'bonus':
      return (
        <span className="absolute top-0 right-0 block h-9 w-9 bg-americanYellow rounded-full transform translate-x-12 -translate-y-2"></span>
      )
    case 'chat':
      return (
        <span className="absolute top-0 right-0 block h-9 w-9 bg-eucalyptus rounded-full transform translate-x-12 -translate-y-2"></span>
      )
    default:
      return null
  }
}
